"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderServiceGroupTask = void 0;
const typeorm_1 = require("typeorm");
const OrderTask_1 = require("./OrderTask");
const ServiceClass_1 = require("../../service/entity/ServiceClass");
const Language_1 = require("../../language/entity/Language");
let OrderServiceGroupTask = class OrderServiceGroupTask extends OrderTask_1.OrderTask {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.OrderServiceGroupTask = OrderServiceGroupTask;
__decorate([
    (0, typeorm_1.ManyToOne)(() => ServiceClass_1.ServiceClass),
    __metadata("design:type", ServiceClass_1.ServiceClass)
], OrderServiceGroupTask.prototype, "serviceClass", void 0);
__decorate([
    (0, typeorm_1.RelationId)((o) => o.serviceClass),
    __metadata("design:type", String)
], OrderServiceGroupTask.prototype, "serviceClassId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Language_1.Language, { nullable: true }),
    __metadata("design:type", Language_1.Language)
], OrderServiceGroupTask.prototype, "sourceLanguage", void 0);
__decorate([
    (0, typeorm_1.RelationId)((o) => o.sourceLanguage),
    __metadata("design:type", String)
], OrderServiceGroupTask.prototype, "sourceLanguageId", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => OrderTask_1.OrderTask, (o) => o.parentTask),
    __metadata("design:type", Array)
], OrderServiceGroupTask.prototype, "serviceTasks", void 0);
exports.OrderServiceGroupTask = OrderServiceGroupTask = __decorate([
    (0, typeorm_1.ChildEntity)('service-group-task'),
    __metadata("design:paramtypes", [Object])
], OrderServiceGroupTask);
